import React from 'react';
import { Button } from 'primereact/button';

import './checkoutFormComplete.scss';
import { useHistory } from 'react-router-dom';
import JsonAnimation from './JsonAnimation';
import checkAnimation from '../assets/animations/check.json';

function CheckoutFormComplete() {
  const history = useHistory();
  return (
    <div className="main_box flex flex-column align-items-center justify-content-center" id="submission">
      <div className="success">
        <JsonAnimation jsonFile={checkAnimation} style={{ width: '100%', height: '200px' }} />
        <h1>Submission Complete !</h1>
      </div>
      <div className="paraf">
        <div className="flex flex-column align-items-start mb-6">
          <h3 className="mb-4">An UPshow Implementation Specialist will be in touch shortly.</h3>
          <p>
            If you have any questions in the meantime, please contact <span className="highlight">support@upshow.tv</span>
          </p>
        </div>
      </div>
      <div className="buttons flex">
        <Button label="Return to Pricing" onClick={() => history.push('/')} />
      </div>
    </div>
  );
}

export default CheckoutFormComplete;
